import { Model as s } from "../../../../../model.js";
class r extends s {
  constructor(e) {
    super(), this.name = e.name, this.email = e.email, this.phone = e.phone, this.externalId = e == null ? void 0 : e.externalId;
  }
}
export {
  r as ShopSessionUserModel
};
//# sourceMappingURL=user.model.js.map
